export { default } from './DestacatCorba';
